export interface ITimeline {
  start: number;
  end: number;
  duration?: number;
  path?: string;
  file_path?: string;
}

export interface ITimelineDefinition {
  duration: number;
  timeline: ITimeline[];
  record?: any;
}
